import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Color, Font } from "../../";
import { MarginProps } from '../../Style/Margin';
import { PaddingProps } from '../../Style/Padding';
var FontStyle = /** @class */ (function () {
    function FontStyle() {
    }
    FontStyle.selector = function (variant) {
        if (!variant)
            return this.body1();
        switch (variant) {
            case 'h1': return this.h1();
            case 'body1': return this.body1();
            case 'body2': return this.body2();
            case 'body3': return this.body3();
            default: return this.body1();
        }
    };
    FontStyle.h1 = function () {
        return {
            fontWeight: 700,
            fontSize: "0.75rem",
            lineHeight: "0.875rem", /** 14px */
        };
    };
    FontStyle.body1 = function () {
        return {
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: "0.875rem", /** 14px */
        };
    };
    FontStyle.body2 = function () {
        return {
            fontWeight: 500,
            fontSize: "0.75rem",
            lineHeight: "0.875rem", /** 14px */
        };
    };
    FontStyle.body3 = function () {
        return {
            fontWeight: 400,
            fontSize: "0.688rem",
            lineHeight: "0.875rem", /** 14px */
        };
    };
    return FontStyle;
}());
/** Font Color */
var FontColor = /** @class */ (function () {
    function FontColor() {
    }
    FontColor.selector = function (color) {
        if (!color)
            return Color.text.primary;
        switch (color) {
            case 'primary': return Color.text.primary;
            case 'secondary': return Color.text.secondary;
            case 'third': return Color.text.third;
            case 'disable': return Color.text.disable;
            default: return color;
        }
    };
    return FontColor;
}());
var getHorizontalAlign = function (props) {
    if (props.center)
        return 'center';
    if (props.horLeft)
        return 'flex-start';
    if (props.horCenter)
        return 'center';
    if (props.horRight)
        return 'flex-end';
    return 'flex-start';
};
var getVerticalAlign = function (props) {
    if (props.center)
        return 'center';
    if (props.verTop)
        return 'flex-start';
    if (props.verCenter)
        return 'center';
    if (props.verBottom)
        return 'flex-end';
    return 'flex-start';
};
var StyledComponent = styled(function (props) {
    var id = props.id, children = props.children, variant = props.variant, color = props.color, size = props.size, singleLine = props.singleLine;
    return (_jsx(Typography, { id: id, sx: __assign(__assign(__assign(__assign(__assign({ whiteSpace: singleLine ? 'nowrap' : 'pre-line', overflow: singleLine ? 'hidden' : 'visible', textOverflow: singleLine ? 'ellipsis' : 'clip', wordBreak: 'break-word' }, FontStyle.selector(variant)), Font.defaultFontSet), MarginProps(props)), PaddingProps(props)), { display: singleLine ? "block" : 'flex', justifyContent: getHorizontalAlign(props), alignItems: getVerticalAlign(props), width: props.width || 'auto', height: props.height || 'auto', fontSize: Font.getFontSize(size) }), color: FontColor.selector(color), children: children }));
})(function () { return ({
    display: "flex",
    fontFeatureSettings: "'clig' off, 'liga' off",
}); });
export default StyledComponent;
